import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CategoryChips } from './Categories';
import { formatDate } from './BlogPosts';
export default function BlogPost() {
  const [post, setPost] = useState(null);
  const [error, setError] = useState('');
  const { slug } = useParams();
  useEffect(() => {
    const controller = new AbortController();
    setPost(null); setError('');
    fetch(`/api/post/${encodeURIComponent(slug)}`, { signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error(r.status === 404 ? 'This post could not be found.' : 'The post could not be loaded. Please refresh to try again.'); return r.json(); })
      .then(setPost).catch(e => { if (e.name !== 'AbortError') setError(e.message); });
    return () => controller.abort();
  }, [slug]);
  if (error) return <article className="main-content"><h1>Unable to load post</h1><p role="alert">{error}</p><Link to="/">Back to the blog</Link></article>;
  if (!post) return <p role="status">Loading post…</p>;
  const date = /^\d{4}-\d{2}-\d{2}/.test(slug) ? slug.slice(0, 10) : null;
  return <article className="main-content prose">
    <div className="article-meta"><Link to="/">← All posts</Link>{date && <time dateTime={date}>{formatDate(date)}</time>}</div>
    <CategoryChips categories={post.categories} />
    <div dangerouslySetInnerHTML={{ __html: post.content }} />
  </article>;
}
